module.exports = __webpack_public_path__ + "img/ic-dropdown-drinking.c2da64fc.svg";